/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsBalanceRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsBalanceResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsBalance = (request: GetSavingsBalanceRequest, options?: CashRequestOptions) => post<GetSavingsBalanceRequest, GetSavingsBalanceResponse>("/2.0/cash/get-savings-balance", request, {...options, rejectOnError: true })